import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {GridDataResult} from '@progress/kendo-angular-grid';
import {ConfigService} from '@q9elements/ui-kit/common';
import {GridFetchParams, GridQuery, GridStore, GridUtils} from '@q9elements/ui-kit/components';
import {Observable, map} from 'rxjs';

import {ImpactGridEntity} from './impact-grid-entity';

@Injectable()
export class ImpactGridQuery extends GridQuery<ImpactGridEntity> {
  constructor(store: GridStore<ImpactGridEntity>, http: HttpClient) {
    super(store, http);
  }

  override fetchEntities(params: GridFetchParams) {
    const refModelId = this.store.getValue().refModelId;
    const url = `${ConfigService.environment.API_ENDPOINT}/refmodel/${refModelId}/dependency/grid`;

    const queryParams = {
      skip: params.skip,
      limit: params.take || 10,
      nodes: JSON.stringify(this.getValue().selectedNodes),
      ...GridUtils.parseCompositeFilter(params.filters)
    };

    return super.fetchEntities<{data: GridDataResult[]; total: number}>(queryParams, url).pipe(
      map(({data, total}) => {
        return {
          entities: this.formatUIValues(data),
          total: total
        };
      })
    );
  }

  selectActive(): Observable<any> {
    return super.selectActive();
  }

  private formatUIValues(data: GridDataResult[]): GridDataResult[] {
    return data.map(item => {
      const mappedItem = {...item};
      for (const key in mappedItem) {
        if (mappedItem[key] === null) {
          mappedItem[key] = '';
        }
      }

      return mappedItem;
    });
  }
}
